import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Reveal, SectionTag, Hairline, ArrowLink, EASE, MaskedLines } from "@/components/Reveal";
import { BRAND } from "@/data/content";

export default function Intro() {
  const navigate = useNavigate();
  return (
    <section
      id="intro"
      data-testid="intro-section"
      className="scroll-mt-20 bg-[#0C0B08] py-20 sm:py-28"
    >
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2 lg:gap-20 lg:px-10">
        <div>
          <Reveal>
            <SectionTag index="01">
              Logibyte Technologies
            </SectionTag>
          </Reveal>
          <h2
              data-testid="intro-headline"
              className="mt-6 font-serif text-2xl font-medium leading-[1.15] tracking-tight text-slate-100 sm:text-3xl lg:text-4xl"
            >
<MaskedLines delay={0.1}>
              We build businesses for
              <br />
              the way the world is evolving.
            </MaskedLines>
</h2>
          <Reveal delay={0.2}>
            <div className="mt-8 space-y-6 text-base font-normal leading-relaxed text-slate-300 sm:text-lg">
              <p>
                Logibyte Technologies develops and operates technology-enabled
                businesses built around real customer needs, structured systems
                and disciplined execution.
              </p>
              <p>
                We combine technology, customer acquisition, operations and
                service delivery to create businesses designed to work
                effectively today and evolve over time.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.3}>
            <ArrowLink to="/about" testid="intro-about-link">
              About Logibyte
            </ArrowLink>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <div
            data-testid="intro-brand-panel"
            className="relative flex min-h-[380px] flex-col justify-between overflow-hidden bg-[#0A0906] p-10 sm:min-h-[440px] sm:p-14"
          >
            <div
              className="pointer-events-none absolute right-[-20%] top-[-20%] h-72 w-72 rounded-full bg-[#D4AF37]/[0.14] blur-[90px]"
              aria-hidden="true"
            />
            <div
              className="pointer-events-none absolute inset-x-10 top-1/2 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent"
              aria-hidden="true"
            />
            <span className="pointer-events-none absolute left-4 top-4 h-5 w-5 border-l border-t border-[#E7CE8B]/40" aria-hidden="true" />
            <span className="pointer-events-none absolute right-4 top-4 h-5 w-5 border-r border-t border-[#E7CE8B]/40" aria-hidden="true" />
            <span className="pointer-events-none absolute bottom-4 left-4 h-5 w-5 border-b border-l border-[#E7CE8B]/40" aria-hidden="true" />
            <span className="pointer-events-none absolute bottom-4 right-4 h-5 w-5 border-b border-r border-[#E7CE8B]/40" aria-hidden="true" />
            <div className="relative flex items-center">
              <div className="relative">
                <span className="pointer-events-none absolute -inset-4 rounded-full border border-[#E7CE8B]/25" aria-hidden="true" />
                <span className="pointer-events-none absolute -inset-8 rounded-full border border-white/5" aria-hidden="true" />
                <img
                  src={BRAND.logo}
                  alt="Logibyte Technologies logo"
                  className="h-16 w-16 rounded-full sm:h-20 sm:w-20"
                />
              </div>
            </div>
            <div className="relative">
              <p className="font-serif text-2xl font-normal leading-snug tracking-tight text-slate-200 sm:text-3xl">
                Building Businesses.
                <br />
                Creating Value.
              </p>
              <div className="mt-8 h-px w-20 bg-gradient-to-r from-[#D4AF37]/70 to-transparent" />
              <p className="mt-6 text-xs font-medium uppercase tracking-[0.3em] text-slate-400">
                Technology · Systems · Operations
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
